import React from 'react';
import { Box, Button, Typography } from '@mui/material';

export default function LoadErrorScreen({ onRetry }) {
  const handleRetry = () => {
    if (onRetry) {
      onRetry();
      return;
    }
    window.location.reload();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: { xs: '50vh', md: '400px' },
        px: 3,
        py: 6,
        textAlign: 'center',
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: 600, color: '#333', mb: 1.5 }}>
        Не удалось загрузить приложение
      </Typography>
      <Typography variant="body1" sx={{ color: '#666', maxWidth: 420, lineHeight: 1.6, mb: 3 }}>
        Возможно, вы используете VPN — отключите его и попробуйте снова.
      </Typography>
      <Button
        variant="contained"
        onClick={handleRetry}
        sx={{
          backgroundColor: '#8B7D6B',
          textTransform: 'none',
          px: 3,
          '&:hover': { backgroundColor: '#756859' },
        }}
      >
        Повторить
      </Button>
    </Box>
  );
}
